import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { UnstyledButton, UnstyledButtonProps } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import styles from '@/PageComponents/Onboarding/components/InfoBadge.module.css';

type InfoBadgeProps = UnstyledButtonProps & Omit<ComponentPropsWithoutRef<'button'>, 'onClick'> & {
    label: string;
    onClick?: () => void;
    /** Just the ⓘ in a circle (completed steps); the label becomes its accessible name. */
    iconOnly?: boolean;
};

/** The light-blue "ⓘ LABEL" pill from the onboarding designs; opens help for the section it sits in. */
const InfoBadge = forwardRef<HTMLButtonElement, InfoBadgeProps>(
    // className is merged: wrappers such as Popover.Target pass their own.
    ({ label, iconOnly, className, ...props }, ref) => (
        <UnstyledButton
            ref={ref}
            className={`${styles.badge} ${iconOnly ? styles.iconOnly : ''} ${className ?? ''}`}
            aria-label={iconOnly ? label : undefined}
            {...props}
        >
            <IconInfoCircle size={19} stroke={2} />
            {!iconOnly && <span>{label}</span>}
        </UnstyledButton>
    ),
);

export default InfoBadge;
